var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',_vm._g(_vm._b({attrs:{"color":_vm.color}},'v-avatar',_vm.$attrs,false),_vm.$listeners),[_c('v-img',{attrs:{"src":_vm.image.src,"lazy-src":_vm.image.srcLazy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }